import React from 'react'

const ContactInfo = ({ userObject }) => {
    return (
        <div className="gray-bg-border mt-3">
            <div className="d-flex justify-content-between gap-2">
                <h6 className="dark-gray f-bold">Contact Info</h6>
                <h6 className="darkgray">

                </h6>
            </div>
            <p className="normal-w darkgray mb-2">
                {userObject?.address} <br />
                {userObject?.town}
                <br />
                {userObject?.stateName}, {userObject?.country} <br />
                {userObject?.zipCode} <br />
            </p>
            <p class="darkgray f-bold mb-2">
                <span class="f-bold">Mobile Phone : </span>{" "}
                <span class="normal-w">{userObject?.mobile}</span>{" "}
            </p>
            <p class="darkgray f-bold mb-2">
                <span class="f-bold">Email : </span>{" "}
                <span class="normal-w">{userObject?.email}</span>{" "}
            </p>
            <p class="darkgray f-bold mb-2">
                <span class="f-bold">Telegram : </span>{" "}
                <span class="normal-w">{userObject?.telegramUsername ? `@${userObject.telegramUsername}` : "-"}</span>{" "}
            </p>
        </div>
    )
}

export default ContactInfo